import React from 'react';
export const Card = ({ children, className }) => {
    return React.createElement("div", { className: `card-item ${className || ''}` }, children);
};
